import { AdminPageHeader } from '@/components/patterns/admin-page'
import LocationForm from '@/components/forms/LocationForm'
import { createFileRoute, notFound } from '@tanstack/react-router'
import { MapPinPlus } from 'lucide-react'

export const Route = createFileRoute('/_authenticated/$orgId/settings/locations/create')({
  beforeLoad: ({ context }) => {
    if (!context.ability.can('create', 'locations')) throw notFound()
  },
  component: RouteComponent,
  loader: () => ({ isReadOnly: false }),
})

export function RouteComponent() {
  return (
    <div className="space-y-4">
      <AdminPageHeader icon={MapPinPlus} title="Create New Location" />
      <LocationForm />
    </div>
  )
}
